import { UploadImgModel } from '@mm/state/model/UploadImgModel';
import React from 'react';
import ImageUpload from '../../ImageUpload/ImageUpload';
import './OptinImageView.scss';

type Props = {
  uploadImage: (img64: UploadImgModel) => any;
  imageUrl: string | null;
  removeImage: () => void;
};

const OptinImageView = ({ uploadImage, imageUrl, removeImage }: Props) => (
  <div>
    <div className="optin-page-builder__title">Add Picture</div>
    <div className="optin-image__image-upload">
      <div className="optin-image__icon-container">
        <ImageUpload
          className="optin-image__uploader"
          hideCropIcon
          couldBeRemoved
          imgUrl={imageUrl || ''}
          uploadImage={uploadImage}
          removeImage={removeImage}
          onRatioChange={() => {}}
        />
      </div>
    </div>
  </div>
);

export default OptinImageView;
